import Router from './routes/Router.jsx';

function App() {
  return <Router />;
}
export default App;
